export * from './new-acopio-dialog.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/new-acopio-dialog/index.ts